import React from 'react';

import clsx from 'clsx';

import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import MailTo from 'components/MailTo';
import PhoneTo from 'components/PhoneTo';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

import styles from './AlreadySetUpWithoutCSM.module.scss';

const DEFAULT_PHONE_NUMBER = '+1 (800)-254-9560';
const DEFAULT_EMAIL = 'contractor@hfsfin.com';

const AlreadySetUpWithoutCSM = () => {
  return (
    <>
      <FormHeader
        title="Based on your application, it appears you are already set up with HFS."
        percent={ProgressBarStatus.Failed}
      />
      <FormBody>
        <p className={styles.csm_header}>Feel free to call or email HFS below with any questions or needs:</p>
        <div className={styles.contact_info_container}>
          <div className={styles.contact_info_item}>
            <PhoneTo
              number={DEFAULT_PHONE_NUMBER}
              linkClassName={clsx('input_label', styles.link)}
              iconClassName={styles.icon}
            />
          </div>
          <div className={styles.contact_info_item}>
            <MailTo
              email={DEFAULT_EMAIL}
              linkClassName={clsx('input_label', styles.link)}
              iconClassName={styles.icon}
            />
          </div>
        </div>
      </FormBody>
    </>
  );
};

export default AlreadySetUpWithoutCSM;
